module.exports = __webpack_public_path__ + "static/img/layout-img-main@w.8c04e04.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life/layout-img-main@w.png
// module id = Nf6x
// module chunks = 0